const coursepackage = {
    state: {
      addCoursePackageDialog: {
        title: '新增课包信息',
        type: 'add'
      }
    },
    getters: {
        addCoursePackageDialog: state => state.addCoursePackageDialog,
    },
    mutations: {
      SET_COURSEPACKAGE_DIALOG_TITLE: (state, type) => {
        console.log("SET_COURSEPACKAGE_DIALOG_TITLE");
        if (type === 'add') {
          state.addCoursePackageDialog.title = '新增课包信息'
          state.addCoursePackageDialog.type = 'add'
        } else {
          state.addCoursePackageDialog.title = '编辑课包信息'
          state.addCoursePackageDialog.type = 'edit'
        }
      }
    },
    actions: {
  
    }
  }
  
  export default coursepackage